import { Indicator } from '../../../Common/Charts/Indicator';
import { useMortalityMobidityChartsDataContext } from './hooks/useMortalityMobidityChartsDataContext';

export const ChildrenMortality = () => {
    const { chartData } = useMortalityMobidityChartsDataContext();

    return (
        <Indicator
            title={'Mortalidade Infantil - Menores de 1 Ano'}
            indicatorValue={chartData?.indicators?.childrenMortality}
            className="aligned-container"
            goalValue={1}
            goalMessage="Meta Aceitável - 10 a cada 1000"
        />
    );
};
